import React, { useState } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import { MdDescription } from "react-icons/md";

export default function TermsAndConditions() {
  const [hovered, setHovered] = useState("t&c");

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Terms & Conditions",
      active: hovered === "t&c" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("t&c"),
      onMouseLeave: () => setHovered("t&c"),
    },
  ];

  const termsSections = [
    {
      title: "1. Introduction",
      desc: "Welcome to VeriMED. These Terms & Conditions (“Terms”) govern your access to and use of our website, mobile applications, services, and care programs. By using VeriMED’s services, you agree to comply with and be bound by these Terms. If you do not agree, you may not use our services.",
      items: null,
    },
    {
      title: "2. Definitions",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
    {
      title: "3. Eligibility",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
    {
      title: "4. Scope of Services",
      desc: "VeriMED provides:",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
    {
      title: "5. Medical Disclaimer",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
    {
      title: "6. Payments & Billing",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
    {
      title: "7. User Responsibilities",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
    {
      title: "8. Privacy & Data Protection",
      items: [
        "“VeriMED” refers to our company, its staff, and authorized representatives.",
        "“Sponsor” means the person, usually a family member living abroad, who enrolls and funds care for a patient in Cameroon.",
        "“Patient” refers to the individual receiving care through VeriMED.",
        "“Care Team” means the licensed physicians, nurses, and coordinators delivering services.",
        "“Services” includes all medical visits, virtual consultations, wellness checks, care coordination, and related offerings provided by VeriMED.",
      ],
    },
  ];

  return (
    <div className="terms_container">
      <Header />

      {/* Hero Section */}
      <div className="terms_hero_section">
        {/* Breadcrumbs */}
        <div className="terms_breadcrumb_wrapper">
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        {/* Background Image */}
        <div className="terms_hero_bg">
          <div className="terms_hero_overlay" />
        </div>

        {/* Gradient Overlay */}
        <div className="terms_gradient_overlay" />

        {/* Hero Content */}
        <div className="terms_hero_content">
          <p className="terms_hero_subtitle">Terms & Conditions</p>
          <h1 className="terms_hero_title">Terms & Conditions</h1>
        </div>
      </div>

      {/* Terms & Conditions Content */}
      <div className="terms_content">
        <div className="terms_header">
          <p>Verimed</p>
          <p>January 12, 2024</p>
        </div>

        {termsSections.map((section, index) => (
          <div key={index} className="terms_section">
            <h2 className="terms_section_title">{section.title}</h2>
            {section.desc && (
              <p className="terms_section_desc">{section.desc}</p>
            )}
            {section.items && (
              <ul className="terms_section_list">
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
